module.exports = __webpack_public_path__ + "img/pc_p3_z1.101fbde2.png";